<template>
  <div v-if="showTaxes" class="tax-terms">
    <booking-city-tax :tax="details.taxes.city" />
    <booking-exclusive-taxes :taxes="details.taxes.exclusive" />
  </div>
</template>
<script lang="ts">
import { Component, Prop, Vue, toNative } from '~/utility/pu-class-decorator'
import { BookingInfo } from '../data/schema'

@Component
class BookingTaxTerms extends Vue {
  @Prop()
  details: BookingInfo

  get showTaxes(): boolean {
    return (
      this.details.taxes.city !== '' ||
      this.details.taxes.exclusive.length > 0 ||
      this.details.taxes.arrival.length > 0
    )
  }
}

export default toNative(BookingTaxTerms)
</script>
<style scoped>
.tax-terms {
  font-size: var(--body);
  border-bottom: 1px solid #ccc;
}

.tax-terms:deep(p),
.tax-terms:deep(div) {
  margin-top: 0.6em;
}
</style>
